module.exports = __webpack_public_path__ + "static/img/servcie-banner2.db166fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/servcie-banner2.jpg
// module id = sv95
// module chunks = 32